import { createSlice } from '@reduxjs/toolkit'

export interface ICommonState {
    selectedRows: any[]
    shareModal: {
        isOpen: boolean
    }
    matchListModal: {
        isOpen: boolean
    }
    enrichModal: {
        isOpen: boolean
        companyId?: string
        contactId?: string
    }
    enrichInfoModal: {
        isOpen: boolean
        matchingSuggestions: any
        companyId: string
    }
    editAssignedListModal: {
        isOpen: boolean
    }
    newWishListModal: {
        isOpen: boolean
        ownerCompany: string
        listName: string
        ids: string[]
    }
}

const initialState: ICommonState = {
    selectedRows: [],
    shareModal: {
        isOpen: false
    },
    matchListModal: {
        isOpen: false
    },
    enrichModal: {
        isOpen: false,
        companyId: '',
        contactId: ''
    },
    enrichInfoModal: {
        isOpen: false,
        matchingSuggestions: null,
        companyId: ''
    },
    editAssignedListModal: {
        isOpen: false
    },
    newWishListModal: {
        isOpen: false,
        ownerCompany: '',
        listName: '',
        ids: []
    }
}

const directorySlice = createSlice({
    name: 'ui/directory',
    initialState,
    reducers: {
        onSelectRows(state, acion) {
            state.selectedRows = acion.payload
        },
        toggleShareModal(state) {
            state.shareModal.isOpen = !state.shareModal.isOpen
        },
        toggleMatchListModal(state) {
            state.matchListModal.isOpen = !state.matchListModal.isOpen
        },
        setEnrichModalInfo(state, action) {
            const objectkeys = Object.keys(action.payload)
            for (const item of objectkeys) {
                state.enrichModal[item] = action.payload[item]
            }
        },
        setEnrichInfoModalInfo(state, action) {
            const objectkeys = Object.keys(action.payload)
            for (const item of objectkeys) {
                state.enrichInfoModal[item] = action.payload[item]
            }
        },
        onChangeEditAssignedListModal(state, action) {
            state.editAssignedListModal.isOpen = action.payload
        },
        onChangeNewWishListModal(state, action) {
            const objectkeys = Object.keys(action.payload)
            for (const item of objectkeys) {
                state.newWishListModal[item] = action.payload[item]
            }
        }
    }
})

export const directoryActions = directorySlice.actions
export default directorySlice.reducer
